import { css } from '@/styled-system/css';

export const inputChipLabelStyles = css.raw({
  color: 'text.neutral',
  hyphens: 'auto',
  textStyle: 'body-sm-bold',
  paddingBlock: 'Chip.padding.vert',
});
